// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__CSBhK","icon":"SortAdornment_icon__1vEPD","up":"SortAdornment_up__1WHZA","down":"SortAdornment_down__sNRrF","active":"SortAdornment_active__hfGhv"};